import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ProductInventory, InventoryTimeline, InventoryKit, RequisicaoEstoqueConsolidado, RequisicaoEstoqueConsolidadoDetalhe, RequisicaoEstoqueConsolidadoLinhaTempo } from 'src/app/@shared/models/estoque-consolidado.model';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class EstoqueConsolidadoService {

  constructor(private http: HttpClient) { }

  listarEstoqueConsolidado(req: RequisicaoEstoqueConsolidado): Observable<HttpResponse<ProductInventory[]>> {
    return this.http.get<ProductInventory[]>(
      // tslint:disable-next-line: max-line-length
      `EstoqueConsolidado/ListarEstoqueConsolidado?${req.filialId ? `filialID=${req.filialId}` : ''}${req.paginaAtual ? `&paginaAtual=${req.paginaAtual + 1}` : ''}${req.itensPorPagina ? `&itensPorPagina=${req.itensPorPagina}` : ''}`,
      { observe: 'response' }
    );
  }

  listarEstoqueConsolidadoDetalhe(req: RequisicaoEstoqueConsolidadoDetalhe): Observable<HttpResponse<InventoryKit[]>> {
    return this.http.get<InventoryKit[]>(
      // tslint:disable-next-line: max-line-length
      `EstoqueConsolidado/ListarEstoqueConsolidadoDetalhe/${req.modeloId}, ${req.filialId}?paginaAtual=${req.paginaAtual + 1}&itensPorPagina=${req.itensPorPagina}`,
      { observe: 'response' }
    );
  }

  listarEstoqueConsolidadoLinhaTempo(req: RequisicaoEstoqueConsolidadoLinhaTempo):
    Observable<HttpResponse<InventoryTimeline[]>> {
    return this.http.get<InventoryTimeline[]>(
      // tslint:disable-next-line: max-line-length
      `EstoqueConsolidado/ListarEstoqueConsolidadoLinhaTempo/${req.prePedidoId}?paginaAtual=${req.paginaAtual + 1}&itensPorPagina=${req.itensPorPagina}`,
      { observe: 'response' }
    );
  }
}
